var React = require('react');

function BenefitsBgBlob (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M557.795 108.867C583.211 185.895 489.548 302.139 381.295 374.966C272.571 447.793 149.257 477.204 76.3035 427.252C3.35031 376.833 -19.2416 247.518 16.9996 155.551C53.2409 63.5832 148.315 8.96286 268.335 1.02657C387.884 -6.90971 532.379 31.3712 557.795 108.867Z","fill":"#F9FAFC"}));
}

BenefitsBgBlob.defaultProps = {"width":"562","height":"453","viewBox":"0 0 562 453","fill":"none"};

module.exports = BenefitsBgBlob;

BenefitsBgBlob.default = BenefitsBgBlob;
